<template>
  <span class="tag"
        :class="getGameStatusStyle(game.gameStatus)">
            <span class="status blink" v-if="isGamePlaying(game)">
              <span class="dot"></span>
            {{ game.gameStatus }}
            </span>
            <span class="status" v-if="isGameNew(game)">
            {{ game.gameStatus }}
            </span>
            <span class="status" v-if="isGameStopped(game)">
            stopped
            </span>
            <span class="status" v-if="isGamePaused(game)">
            paused
            </span>
          </span>
</template>

<script>
  import gameHelper from '../../helpers/game-helper'
  import GAME_STATUS from '../../enums/gameStatus'

  export default {
    name: 'GameStatusTag',
    props: {
      game: {
        gameStatus: '',
      }
    },
    methods: {
      getGameStatusStyle(status) {
        if (status === GAME_STATUS.PLAYING) {
          return 'is-success'
        } else if (status === GAME_STATUS.PAUSED) {
          return 'is-info'
        } else if (status === GAME_STATUS.STOPPED) {
          return 'is-danger'
        } else {
          return 'is-warning'
        }
      },
      isGameStopped: gameHelper.isGameStopped,
      isGamePaused: gameHelper.isGamePaused,
      isGamePlaying: gameHelper.isGamePlaying,
      isGameNew: gameHelper.isGameNew,
    }
  }
</script>

<style scoped>
  .status {
    font-weight: bold;
    font-size: 10pt;
  }

  .dot {
    height: 8px;
    width: 8px;
    background-color: #e30000;
    border-radius: 50%;
    display: inline-block;
  }

  .blink {
    animation: blinker 1.5s cubic-bezier(.5, 0, 1, 1) infinite alternate;
  }

  @keyframes blinker {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
</style>
